import React from "react";

import { TextField } from "@graffer-inc/console-design-kit";

import { validateCreateServiceAccount } from "../../../application/domain/service-account/service-account-validation";
import { CreateServiceAccountInput } from "../../../graphql/generated/types";
import { ServiceAccountCommonUpsertForm } from "./service-account-common-upsert-form";

type Props = {
  createServiceAccountInput: CreateServiceAccountInput;
  onChange: (createServiceAccountInput: CreateServiceAccountInput) => void;
  tenantId: string;
  validationState: ReturnType<typeof validateCreateServiceAccount>;
  shouldDisplayError: boolean;
};

export const ServiceAccountCreateForm: React.FC<Props> = ({
  createServiceAccountInput,
  onChange,
  tenantId,
  validationState,
  shouldDisplayError,
}) => {
  return (
    <>
      <div className="columns">
        <div className="column">
          <TextField
            label="アカウント名"
            value={createServiceAccountInput.accountName}
            onChange={(e) => {
              onChange({
                ...createServiceAccountInput,
                accountName: e.target.value,
              });
            }}
            required
            placeholder="アカウント名を入力してください"
            description={"256文字以内の英数字と記号を用いてください。"}
            errorMessages={validationState.accountName}
            shouldDisplayError={shouldDisplayError}
          />
        </div>
      </div>

      <ServiceAccountCommonUpsertForm
        input={createServiceAccountInput}
        onChange={onChange}
        tenantId={tenantId}
        validationState={validationState}
        shouldDisplayError={shouldDisplayError}
      />
    </>
  );
};
